<template lang="pug">

  //-
    -
    -
    - GROUP USERS REPORT LOADING
    -
    -
    -

  .sosReportLoaderDialog(v-if="show")
    .sosReportLoaderDialog__inner

      .sosReportLoaderDialog__header
        | Exportação de usuários

      .sosReportLoaderDialog__body

        .mb-5.sosReportLoaderDialog__loaderWrapper(v-if="reportStatus !== 'ERROR' && reportStatus !== 'PROGRESS_ERROR' && reportStatus !== 'DONE'")
          .buttonLoader
            span

        .mb-1.groupProgressBar(v-if="reportStatus === 'GENERATING' && reportProgress !== 'WAITING'")
          .groupProgressBarInner(:style="{ width: reportProgress + '%' }")

        .mb-7(v-if="reportStatus === 'DONE'")
          a(:href="reportMessage" target="_blank").sosReportLink
            | O relatório não abriu?
            br
            | Clique aqui!
        .mb-7(v-else)
          .sosReportLoaderMessage(v-html="reportMessage")

        .mt-6.text-center
          sos-button(@buttonClick="close" size="medium" buttonLabel="Fechar" buttonIcon="mdi-close" buttonIconSize="20" :disabled="reportStatus !== 'ERROR' && reportStatus !== 'PROGRESS_ERROR' && reportStatus !== 'DONE'")

</template>

<script>

  // Utilitários
  import { parseJson } from '@/functions'

  import { apiOpenReport } from '@/services/report'

  import SosButton from '@/components/SosButton'

  export default {
    name: 'ExportGroupUsersModal',

    components: {
      'sos-button': SosButton,
    },

    data () {
      return {
        show: false,

        reportStatus: 'WAITING',
        reportMessage: 'Por favor, aguarde...',
        reportProgress: 'WAITING',
      }
    },

    methods: {
      //
      // ABRIR
      //

      async open (reportUrl)
      {
        this.show = true

        try
        {
          const response = await fetch(reportUrl)

          // Verifica se a resposta foi bem-sucedida
          if (!response.ok)
          {
            this.reportStatus = 'ERROR'
            this.reportMessage = 'Não foi possível solicitar o relatório. Por favor, tente novamente ou fale com o nosso suporte.'
          }
          else
          {
            const reader = response.body.getReader()
            const decoder = new TextDecoder()
            let done = false

            // Processa cada resposta do endpoint até terminar
            while (!done)
            {
              // Lê os dados do stream
              const { value, done: readerDone } = await reader.read()
              done = readerDone

              // Decodifica os dados em texto e mostra
              const chunk = decoder.decode(value, { stream: true })

              // Exibe progresso na tela
              const parsedChunk = parseJson(chunk)

              console.log('::: [DEBUG] PROGRESS:', { done, value, chunk, parsedChunk })

              if (!!parsedChunk === true && (parsedChunk.status || '').length !== 0)
              {
                this.reportStatus = parsedChunk.status
                this.reportMessage = parsedChunk.message || ''
                this.reportProgress = parsedChunk.progress || this.reportProgress

                if (parsedChunk.status === 'DONE' && (parsedChunk.message || '').length !== 0) apiOpenReport(parsedChunk.message, true)
              }
            }
          }
        }
        catch (e)
        {
          this.reportStatus = 'ERROR'
          this.reportMessage = 'Erro ao solicitar o relatório.<br />Motivo: ' + (e.message || 'Desconhecido.')
        }
      },

      //
      // FECHAR
      //

      close ()
      {
        // if (this.loading) return false

        this.show = false
        this.reportStatus = 'WAITING'
        this.reportMessage = 'Por favor, aguarde...'
        this.reportProgress = 'WAITING'
      },
    },
  }

</script>

<!-- <style lang="scss" scoped></style> -->
